export default function translate(i18n, propriete) {
  if (propriete.startsWith('cgvs')) {
    const prefixI18n = 'catalogue.validation.cgv.';
    if (propriete.endsWith('Remise')) return i18n.t(`${prefixI18n}remise`);
    if (propriete.endsWith('LibelleRemiseId')) return i18n.t(`${prefixI18n}libelleRemise`);
  }
  return propriete;
}
